/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import clone_object from "../lib/clone_object";

export default function WhatsNewPopupMaker({ data, imgUpload, setData }) {
  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        min-height: 500px;
        gap: 0.5rem;
      `}
    >
      <div
        css={css`
          width: 100%;
          border: 1px dashed gray;
          position: relative;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        `}
      >
        <img
          src={data.popup_img.src}
          alt=""
          css={css`
            width: 100%;
            object-fit: contain;
          `}
          draggable={false}
        />
        <div
          css={css`
            text-align: center;
            padding: 0.5rem 0;
            position: relative;
          `}
        >
          <button
            css={css`
              background: ${data.meta_popup.background};
              border: 0;
              color: ${data.meta_popup.color};
              width: 90%;
              padding: 0.75rem 0;
              font-size: 18px;
              border-radius: 999px;
            `}
          >
            자세히 보기
          </button>
          <div
            css={css`
              position: absolute;
              top: 0;
              right: 0;
            `}
          >
            <input
              type="color"
              value={data.meta_popup.color}
              onChange={(e) =>
                setData((state) => {
                  const copy = clone_object(state);
                  copy.meta_popup.color = e.target.value;
                  return copy;
                })
              }
            />
            <input
              type="color"
              value={data.meta_popup.background}
              onChange={(e) =>
                setData((state) => {
                  const copy = clone_object(state);
                  copy.meta_popup.background = e.target.value;
                  return copy;
                })
              }
            />
          </div>
        </div>
      </div>
      <div
        css={css`
          width: 300px;
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        `}
      >
        <label>
          <Button
            variant="outlined"
            onClick={(e) => e.target.nextSibling.click()}
            css={css`
              width: 100%;
            `}
          >
            이미지 업로드
          </Button>
          <input
            type="file"
            css={css`
              display: none;
            `}
            name="popup_img"
            onChange={imgUpload}
            accept="image/*"
          />
        </label>
      </div>
    </div>
  );
}
